import { PageWrapper } from '@src/components';
import { useTranslation } from 'react-i18next';
import {
  ActiveESims,
  Banner,
  PopularCountries,
  Promotions,
} from './components';
import { useEffect, useRef, useState } from 'react';
import { useGetCurrentEsimsQuery } from '@src/services/esim/esimApiSlice';
import { CountryRegionSearch } from '@src/components/CountryRegionSearch';
import { useMediaQuery } from 'react-responsive';

export function Dashboard() {
  const { t } = useTranslation();
  const isLarge = useMediaQuery({ minWidth: 1024 });

  const [activeEsimHeight, setActiveEsimHeight] = useState<number>();
  const esimRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!esimRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      if (esimRef.current) {
        setActiveEsimHeight(esimRef.current.offsetHeight);
      }
    });

    resizeObserver.observe(esimRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  const { data: esims, isLoading } = useGetCurrentEsimsQuery();

  const hasEsims = isLoading || (esims && esims?.length > 0);

  return (
    <PageWrapper title={t('pages.dashboard.title')}>
      <div className='block md:hidden mb-4'>
        <CountryRegionSearch />
      </div>
      <div className='space-y-4 lg:flex lg:justify-between lg:space-x-6 lg:space-y-0 items-stretch'>
        <div
          ref={esimRef}
          className={`h-[200px] w-full ${hasEsims && 'lg:w-1/3'}`}
        >
          <ActiveESims />
        </div>

        {hasEsims && (
          <div
            className='w-full md:block lg:block lg:w-2/3'
            style={{
              height:
                isLarge && activeEsimHeight ? `${activeEsimHeight}px` : 'auto',
            }}
          >
            <Banner />
          </div>
        )}
      </div>
      <PopularCountries />
      <Promotions />
    </PageWrapper>
  );
}
